export function wrapInSvgTag(
  svg: string,
  attrs: Record<string, string | number> = {},
): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" ${Object.entries(
    attrs,
  ).reduce(
    (acc, [key, value]) => `${acc} ${key}="${value}"`,
    '',
  )}>${svg}</svg>`;
}
